<div class="premium-toast light-glass">
  <div class="icon-wrapper">
    <i class="fa fa-bell"></i>
  </div>
  <div class="message-wrapper">
    {{ data }}
  </div>
  <div class="close-btn" (click)="snackBarRef.dismiss()">
    <i class="fa fa-times"></i>
  </div>
</div>